import { FC } from "react";
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import theme from "src/theme/light";
import InputQuantidade from "src/framework/components/forms/inputs/InputQuantidade";
import { Formater, TypeRecords } from "src/framework/commons/Formater";

interface FormItensAvulsosProperties {
    formState: any;
}

const useStyles = makeStyles({
  warningText: {
    color: theme.palette.warning.main,
    fontWeight: 600,
  }
})

const FormItensAvulsos: FC<FormItensAvulsosProperties> = ({ formState }) => {
    const classes = useStyles();

    if(!formState?.avulsos) return <></>
    return (
        <div className="row">
            <div className="X12">
                <TableContainer 
                  component={Paper}
                  sx={{
                    maxHeight: "calc(100vh - 300px)",
                    overflow: "auto"
                  }}
                  >
                    <Table stickyHeader>
                        <TableHead>
                        <TableRow style={{backgroundColor: "#F2F2F2"}}>
                            <TableCell>
                            <Typography style={{fontSize: "14px"}} fontWeight="bold">Itens</Typography>
                            </TableCell>
                            <TableCell align="center">
                            <Typography style={{fontSize: "14px"}} fontWeight="bold">Preço Unitário</Typography>
                            </TableCell>
                            <TableCell align="center">
                            <Typography style={{fontSize: "14px"}} fontWeight="bold">Quantidade</Typography>
                            </TableCell>
                            <TableCell align="center">
                            <Typography style={{fontSize: "14px"}} fontWeight="bold">Preço Total</Typography>
                            </TableCell>
                        </TableRow>
                        </TableHead>
                        <TableBody>
                        {formState?.avulsos.map((item:any) => {
                            const total = item?.quantidade * item.valor;
                            const { componente } = item;
                            return (
                            <TableRow key={item.id}>
                                <TableCell>
                                    <Typography variant='body1' color='textPrimary'>
                                        <strong>{componente?.nome}</strong>
                                    </Typography>
                                    <Typography variant='body2' color='textSecondary'>
                                        <span className={classes.warningText}><strong>Informações:</strong></span> {componente?.descricao}
                                    </Typography>
                                </TableCell>
                                <TableCell align="center">{Formater.toString(item.valor, TypeRecords.CURRENCY)}</TableCell>
                                <TableCell align="center">
                                <Box display="flex" alignItems="center" justifyContent="center">
                                    <InputQuantidade value={item?.quantidade || 0} highlightField={false} onChange={() => {}} disabled={true} />
                                </Box>
                                </TableCell>
                                <TableCell align="center">{Formater.toString(total, TypeRecords.CURRENCY)}</TableCell>
                            </TableRow>
                            );
                        })}
                        </TableBody>
                    </Table>
                    </TableContainer>
            </div>
        </div>
    );
}

export { FormItensAvulsos }